import { useGoldConfig } from '@iheartjane/data-access/react-query';
import { useMemo } from 'react';

export const useStoreHasGoldConfig = (storeId: string | number) => {
  const { data: goldConfig, isPending: isLoadingGoldConfig } = useGoldConfig();

  return useMemo(() => {
    if (isLoadingGoldConfig || !goldConfig) return false;
    return goldConfig.store_ids.includes(Number(storeId));
  }, [goldConfig, isLoadingGoldConfig, storeId]);
};
